import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DcrCDDBDrug } from '../../models/drug';
import { RpoToolService } from '../../services/rpo-tool.service';
import * as constants from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { routePaths } from 'src/app/config/app-constants';
import { ImportWizardAddNewDrugComponent } from './../import-wizard-add-new-drug/import-wizard-add-new-drug.component';



@Component({
  selector: 'app-import-wizard-drug-classification-resolution',
  standalone: false,
  templateUrl: './import-wizard-drug-classification-resolution.component.html',
  styleUrl: './import-wizard-drug-classification-resolution.component.scss'
})
export class ImportWizardDrugClassificationResolutionComponent implements OnInit {
  caseNo: string = '';
  dataSource = new MatTableDataSource<DcrCDDBDrug>();

  drugName: string = '';
  ndc: string = '';
  owner: string = '';
  source: string = '';
  strength: string = '';
  manufacturer: string = '';
  productType: string = '';
  priority: string = '';
  requestor: string = '';
  age: string = '';
  sfStatus: string = '';
  caseNumber: string = '';
  account: string = '';

  constructor(
    public dialogRef: MatDialogRef<ImportWizardDrugClassificationResolutionComponent>,
    private rpoService: RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private dialog: MatDialog,
    private toastService: ToastService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.caseNo = data?.caseNo;
  }
  ngOnInit(): void {
    this.getDcrDrugData();
  }
  redirectToDetailsPage(rowId: any, dataSourceId: number) {
    this.route.navigate([`/${routePaths.DRUG_MANAGEMENT}/drug-details`, rowId, dataSourceId,this.caseNumber]);
    this.dialogRef.close();
  }
  getDcrDrugData() {
    let dcrKey = 'dcrKey'
    this.ngxLoader.start(dcrKey);
    this.rpoService.getDcrDrugsByCaseNo(
      this.caseNo
    ).subscribe({
      next: (response) => {
        let result = response.data;


        this.ngxLoader.stop(dcrKey);
        this.dataSource.data = result.cddbDrugs

        this.drugName = result.dcrDrug?.drugName;
        this.ndc = result.dcrDrug?.ndc;
        this.owner = result.dcrDrug?.owner;
        this.source = result.dcrDrug?.source;

        this.strength = result.drcDrug?.strength;
        this.manufacturer = result.dcrDrug?.manufacturer;
        this.productType = result.dcrDrug?.productType;
        this.priority = result.dcrDrug?.priority;
        this.requestor = result.dcrDrug?.requestor;
        this.age = result.dcrDrug?.age;
        this.sfStatus = result.dcrDrug?.sfStatus;
        this.account = result.dcrDrug?.account;
        this.caseNumber = result.dcrDrug?.caseNumber;


      },
      error: (error: HttpErrorResponse) => {
        this.ngxLoader.stop(dcrKey);
        console.log(error);
        this.toastService.openToast(
          error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    })
  }

  openImportWizardNewDrug() {
    const dialogRef = this.dialog.open(ImportWizardAddNewDrugComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.getDcrDrugData;
      }
    });

  }

  
}